import { combineReducers } from 'redux';
import { connectRouter } from 'connected-react-router';
import storyDetailsReducer from './../pages/ViewerPage/reducer.js';
import updatePointOfInterestIdReducer from './../containers/Map/reducer.js';

export default history =>
  combineReducers({
    router: connectRouter(history),
    storyDetailsReducer,
    updatePointOfInterestIdReducer
  });
